export default __webpack_public_path__ + "static/media/2379.6bcd0787.png";